import { Link } from 'react-router-dom';

const FOOTER_LINKS = [
  {
    heading: 'Product',
    links: [
      { label: 'Privacy layer', href: '#privacy' },
      { label: 'Features', href: '#features' },
      { label: 'Pricing', href: '#pricing' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'Our approach', href: '#approach' },
      { label: 'FAQ', href: '#faq' },
      { label: 'Contact', href: '#contact' },
      { label: 'Support', href: '/support' },
    ],
  },
  {
    heading: 'Get started',
    links: [
      { label: 'Individual account', href: '/signup?type=individual' },
      { label: 'Organization account', href: '/signup?type=organization' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-line bg-surface dark:border-midnight-600 dark:bg-midnight-800">
      <div className="container-page grid grid-cols-2 gap-10 py-16 sm:grid-cols-4">
        <div className="col-span-2 flex flex-col gap-4 sm:col-span-1">
          <Link to="/" className="flex items-center gap-2 text-lg font-extrabold tracking-tight text-ink dark:text-white">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-brand-gradient text-sm font-black text-white">
              P
            </span>
            Piua AI
          </Link>
          <p className="max-w-xs text-sm leading-relaxed text-muted dark:text-subtle">
            The AI assistant that keeps your business, your business.
          </p>
        </div>

        {FOOTER_LINKS.map((group) => (
          <div key={group.heading} className="flex flex-col gap-3">
            <h3 className="text-sm font-semibold text-ink dark:text-white">{group.heading}</h3>
            {group.links.map((link) =>
              link.href.startsWith('/') ? (
                <Link
                  key={link.label}
                  to={link.href}
                  className="text-sm text-muted transition hover:text-brand-600 dark:text-subtle dark:hover:text-brand-300"
                >
                  {link.label}
                </Link>
              ) : (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-sm text-muted transition hover:text-brand-600 dark:text-subtle dark:hover:text-brand-300"
                >
                  {link.label}
                </a>
              )
            )}
          </div>
        ))}
      </div>

      <div className="border-t border-line py-6 dark:border-midnight-600">
        <div className="container-page flex items-center justify-center text-xs text-subtle">
          <p>&copy; {new Date().getFullYear()} Piua AI. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
